import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReturnRoot } from '@repo/sdk'

import { BuyerLink } from '../../components/BuyerLink'

interface ReturnBuyerInfoCardProps {
  returnData: ReturnRoot
}

export function ReturnBuyerInfoCard({ returnData }: ReturnBuyerInfoCardProps) {
  const { t } = useTranslation()

  return (
    <Card title={t('pages.returns.sections.buyerInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.returns.fields.buyerNickname')}>
          <BuyerLink buyer={returnData.buyer} showAvatar />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
